import axios from 'axios'

export const photoDownloader = async (url: string, fileName: string) => {
  try {
    const originalPhoto = await axios.get(url, {
      responseType: 'blob',
    })

    if (originalPhoto.data) {
      const reader = new FileReader()

      reader.onload = () => {
        const dataUrl = reader.result as string
        const link = document.createElement('a')
        link.download = fileName.replace(/([^a-z0-9 ])/gi, '_')
        link.href = dataUrl
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }

      reader.readAsDataURL(originalPhoto.data)
    }
  } catch (e) {
    if (e instanceof Error) {
      console.log('Photo download error:', e.message)
    } else {
      console.log(e)
    }
  }
}
